import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useChangePassword = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);

  const changePasswordRequest = ({
    currentPassword,
    newPassword,
    onSuccess,
  }) => {
    setChangePasswordLoading(true);
    axiosClient
      .put(`SettingAccount/User/ChangePassword`, {
        currentPassword,
        newPassword,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`رمز عبور با موفقیت تغییر کرد`, {
            variant: 'success',
          });
          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setChangePasswordLoading(false));
  };
  return { changePasswordRequest, changePasswordLoading };
};

export { useChangePassword };
